import { render } from "./UgmMachineInfo.vue?vue&type=template&id=8960f6fc&scoped=true"
import script from "./UgmMachineInfo.vue?vue&type=script&lang=js"
export * from "./UgmMachineInfo.vue?vue&type=script&lang=js"

import "./UgmMachineInfo.vue?vue&type=style&index=0&id=8960f6fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8960f6fc"]])

export default __exports__